// hooks
import useComponents, { useSelectedComponent } from "../../../Hooks/Display/useComponents";

// components
import GroupHeading from "./GroupHeading";
import Table from "./Table";

// utils
import { getComponentByProperty } from "../Components/utils";
import Cards from "./Cards";
import Calendar from "./Calendar";
import List from "./List";
import SplitView from "./SplitView";
import Kanban from "./Kanban";
import Summary from "./Summary";
import ProgressBar from "./ProgressBar";
import View from "./View";
import Reference from "./Reference";
import History from "./History";
import Discussion from "./Discussion";
import Tab from "./Tab";
import TabContainer from "./TabContainer";
import { useSelectedPage } from "../../../Hooks/Display/usePages";
import SpecificHeading from "./SpecificHeading";
import StackedSection from "./StackedSection";
import Form from "./Form";
import Content from "./Content";

// Hooks
import useComponentPropertiesContext from "../../../Hooks/Display/useComponentProperties";
import { OverlayLoader } from "../../Shared/Loader/OverlayLoader";
import GanttChart from "./GanttChart";
import SplitSection from "./SplitSection";

function EditComponentForm() {

    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();

    const [componentState] = useComponentPropertiesContext();

    const componentFormMap = {
        "Entity Group": {
            "Heading": <GroupHeading />,
            "Gantt Chart": <GanttChart />,
            "Table": <Table />,
            "Cards": <Cards />,
            "Calendar": <Calendar />,
            "List": <List />,
            "Split View": <SplitView />,
            "Kanban": <Kanban />,
            "Content": <Content />
        },
        "Entity Specific": {
            "Heading": <SpecificHeading />,
            "Summary": <Summary />,
            "Progress Bar": <ProgressBar />,
            "View": <View />,
            "Reference": <Reference />,
            "History": <History />,
            "Discussion": <Discussion />,
            "Tab": <Tab />,
            "Tab Container": <TabContainer />,
            "Stacked Section": <StackedSection />,
            "Split Section": <SplitSection />,
            "Form": <Form />,
            "Content": <Content />
        }
    }

    return (
        <>
            {
                (componentState.isSaving || componentState.isPublishing) &&
                <OverlayLoader />
            }
            {
                selectedPage && selectedComponent && componentFormMap[selectedPage.pageType][selectedComponent.componentType]
            }
            {
                (!selectedPage || !selectedComponent) && <h1>Nothing Selected</h1>
            }
            {
                selectedPage && selectedComponent && !componentFormMap[selectedPage.pageType][selectedComponent.componentType] &&
                <h1>Component Form Not Found</h1>
            }
        </>
    )
}

export default EditComponentForm;